export const LANGUAGE_COOKIE_NAME = "locale";
export const FALLBACK_LANGUAGE = "ar";
